// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import { router } from './router';
import { store } from './store';
import Toastr from 'vue-toastr';
import Vuetify from 'vuetify';
import 'babel-polyfill';
import './style/index.scss';
import 'vuetify/dist/vuetify.min.css';
// import toastr scss file: need webpack sass-loader
require('vue-toastr/src/vue-toastr.scss');
// Register plugin

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(Toastr);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js